import * as React from "react";
import { useLocation } from "react-router-dom";
import { useCountryValue } from "../Contexts/CountryContext";
import * as Action from "../Types/ReducerTypes";
import { GoogleEvent, sendGtmEvent } from '../GoogleTagManager';
import { setCookie } from "../Cookie";
function CountrySelector(_a) {
  var _b = _a.hideText,
    hideText = _b === void 0 ? false : _b;
  var _c = useCountryValue(),
    state = _c[0],
    dispatch = _c[1];
  var location = useLocation();
  if (location.pathname !== '/' && location.pathname.match(/^\/(profil|kategorie|seite)\/.+$/) === null) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, "\u00A0");
  }
  function de() {
    dispatch({
      type: Action.COUNTRY_CHANGE_COUNTRY,
      country: "de"
    });
    sendGtmEvent(GoogleEvent.HEADER_COUNTRY_SELECTION, "de");
    setCookie('selectedRegion', 'de', 365);
  }
  function ch() {
    dispatch({
      type: Action.COUNTRY_CHANGE_COUNTRY,
      country: "ch"
    });
    sendGtmEvent(GoogleEvent.HEADER_COUNTRY_SELECTION, "ch");
    setCookie('selectedRegion', 'ch', 365);
  }
  function at() {
    dispatch({
      type: Action.COUNTRY_CHANGE_COUNTRY,
      country: "at"
    });
    sendGtmEvent(GoogleEvent.HEADER_COUNTRY_SELECTION, "at");
    setCookie('selectedRegion', 'at', 365);
  }
  var textClass = "switchtext c-language-select__text";
  if (hideText) {
    textClass = "switchtext c-language-select__text hide-on-tablet hide-on-mobile";
  }
  var buttons = [/*#__PURE__*/React.createElement("img", {
    key: 'de',
    onClick: de,
    width: "27",
    height: "24",
    src: "/img/DE_1x.png",
    className: 'c-language-select__flag ' + (state.country === "de" ? "active c-language-select__flag--active" : ""),
    srcSet: '/img/DE_2x.png 2x,/img/DE_3x.png 3x,/img/DE_4x.png 4x,/img/DE_1x.png',
    alt: "Deutschland"
  }), /*#__PURE__*/React.createElement("img", {
    key: 'at',
    onClick: at,
    width: "27",
    height: "24",
    src: "/img/AT_1x.png",
    className: 'c-language-select__flag ' + (state.country === "at" ? "active c-language-select__flag--active" : ""),
    srcSet: '/img/AT_2x.png 2x,/img/AT_3x.png 3x,/img/AT_4x.png 4x,/img/AT_1x.png',
    alt: "Österreich"
  }), /*#__PURE__*/React.createElement("img", {
    key: 'ch',
    onClick: ch,
    width: "27",
    height: "24",
    src: "/img/CH_1x.png",
    className: 'c-language-select__flag ' + (state.country === "ch" ? "active c-language-select__flag--active" : ""),
    srcSet: '/img/CH_2x.png 2x,/img/CH_3x.png 3x,/img/CH_4x.png 4x,/img/CH_1x.png',
    alt: "Schweiz"
  })];
  switch (window.preSelectRegion) {
    case "ch":
      buttons.splice(0, 0, buttons.splice(2, 1)[0]);
      break;
    case "at":
      buttons.splice(0, 0, buttons.splice(1, 1)[0]);
      break;
    default:
      // Do nothing
      break;
  }
  return /*#__PURE__*/React.createElement("span", {
    className: "langselect c-language-select"
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrap"
  }, /*#__PURE__*/React.createElement("span", {
    className: textClass
  }, "Du rufst an aus:"), /*#__PURE__*/React.createElement("span", {
    className: "switchflags c-language-select__flags",
    id: "dachSelection"
  }, buttons)));
}
export default CountrySelector;